<script>
import { useModeStore } from '../store/mode.js';
import { getPaginationBackgroundColor } from '../utils/commonFunctions.js';

import PreviousPageBlack from '../assets/icons/previous_page_black.png';
import PreviousPageWhite from '../assets/icons/previous_page_white.png';
import NextPageBlack from '../assets/icons/next_page_black.png';
import NextPageWhite from '../assets/icons/next_page_white.png';

export default {
    props: {
        showingFrom: Number,
        showingTo: Number,
        totalItems: Number,
        totalPages: Number,
        currentPage: Number,
        itemsPerPage: Number,
        itemsPerPageOptions: {
        type: Array,
        default: () => [10, 25, 50, 100],
        },
    },
    setup() {
        const modeStore = useModeStore();
        const paginationBackgroundColor = getPaginationBackgroundColor();

        return {
            modeStore,
            PreviousPageBlack,
            PreviousPageWhite,
            NextPageBlack,
            NextPageWhite,
            paginationBackgroundColor,
        };
    },
    mounted() {
    },
    computed: {
        pages() {
            const total = this.totalPages;
            const current = this.currentPage;
            const delta = 2; // number of pages around the current one
            const range = [];
            // const rangeWithDots = [];

            let left = Math.max(2, current - delta);
            let right = Math.min(total - 1, current + delta);

            range.push(1); // Always show first page

            if (left > 2) {
                range.push('...');
            }

            for (let i = left; i <= right; i++) {
                range.push(i);
            }

            if (right < total - 1) {
                range.push('...');
            }

            if (total > 1) {
                range.push(total); // Always show last page
            }

            return range;
        },

        showNextButton() {
            return this.totalItems > this.currentPage * this.itemsPerPage;
        },
    },
}
</script>

<template>
    <div class="flex flex-col md:flex-row md:items-center justify-between p-2 gap-2">
        <!-- Description -->
        <div v-show="totalItems" class="pagination-description text-sm md:block hidden text-gray-500">
            {{ $t('pagination.details', {firstItem: showingFrom, lastItem: showingTo, totalItems: totalItems})}}
        </div>

        <!-- Mobile View (Compact) -->
        <div class="flex justify-center items-center md:hidden gap-2">
            <button
                class="btn px-3 py-1"
                :disabled="currentPage === 1"
                @click="$emit('change-page', currentPage - 1)">
                Prev
            </button>

            <span class="text-sm font-medium">Page {{ currentPage }} of {{ totalPages }}</span>

            <button
                class="btn px-3 py-1"
                :disabled="!showNextButton"
                @click="$emit('change-page', currentPage + 1)">
                Next
            </button>
        </div>

        <!-- Desktop View (Full) -->
        <div class="join rounded-md hidden md:flex">
            <!-- Prev -->
            <button
                class="join-item btn border-none"
                :class="modeStore.selectedMode === 'light' ? 'text-black bg-custom-light-gray' : 'text-white bg-black bg-opacity-30'"
                :disabled="currentPage === 1"
                @click="$emit('change-page', currentPage - 1)">
                <img :src="modeStore.selectedMode === 'light' ? PreviousPageBlack : PreviousPageWhite" />
            </button>

            <!-- Page Buttons -->
            <button
                v-for="(page, index) in pages"
                :key="index"
                class="join-item btn border-none"
                :class="page == currentPage ? paginationBackgroundColor : modeStore.selectedMode === 'light' ? 'text-black bg-custom-light-gray' : 'text-white bg-black bg-opacity-30'"
                @click="page !== '...' && page !== currentPage && $emit('change-page', page)">
                {{ page }}
            </button>

            <!-- Next -->
            <button
                class="join-item btn border-none"
                :class="modeStore.selectedMode === 'light' ? 'text-black bg-custom-light-gray' : 'text-white bg-black bg-opacity-30'"
                :disabled="!showNextButton"
                @click="$emit('change-page', currentPage + 1)">
                <img :src="modeStore.selectedMode === 'light' ? NextPageBlack : NextPageWhite" />
            </button>
        </div>  
    </div>
</template>


<style scoped>
    .text-black {
        color: black;
        border: none;
    }
</style>